module.exports = __webpack_public_path__ + "static/media/zwartecross.9344fbaf.jpg";